import React, { useState, useEffect } from "react";
import { Route, Redirect, Navigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ProtectedRoute = ({ children, allowedRoles }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      axios.defaults.withCredentials = true;
      try {
        const response = await axios.get(`${API_URL}/admin/verifyAdmin`);
        console.log(("Response:", response.data));
        setUser(response.data);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <p>Caricamento...</p>;
  }

  if (error) {
    return <Navigate to="/login" />;
  }

  if (user && allowedRoles.includes(user.ruolo)) {
    return children; // Se il ruolo corrisponde, visualizza i children
  }

  return <Navigate to="/unauthorized" />; // Se il ruolo non corrisponde, reindirizza
};

export default ProtectedRoute;
